import {
  ErrorState, IncidentForm, IncidentRecord, LoadingState, Notice, Stack, useApi, useI18n,
} from '@daghfal/core';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';

/**
 * Records an incident for one child (FR-CHD-11), from the child's screen.
 *
 * Online only, unlike the quick actions: an incident tells the family at once (FR-CHD-12), and a teacher must know
 * it has gone rather than find it waiting in the queue an hour later. Once saved, the record is shown as the family
 * will read it.
 */
export function RecordIncident() {
  const api = useApi();
  const { t } = useI18n();
  const { childId } = useParams();
  const id = Number(childId);
  const [recorded, setRecorded] = useState<number | null>(null);

  const child = useQuery({ queryKey: ['child', id], queryFn: () => api.children.get(id), enabled: Number.isFinite(id) });

  if (child.isPending) return <LoadingState />;
  if (child.isError) return <ErrorState error={child.error} onRetry={() => void child.refetch()} />;

  const name = child.data.preferredName
    ? `${child.data.preferredName} ${child.data.lastName}`
    : `${child.data.firstName} ${child.data.lastName}`;

  return (
    <Stack>
      <Link className="dg-button dg-button--ghost" to={`/child/${id}`}>{t('incident.back', { name })}</Link>
      {recorded === null ? (
        <IncidentForm childId={id} onRecorded={(incident) => setRecorded(incident.id)} />
      ) : (
        <>
          <Notice tone="success">{t('incidents.recorded')}</Notice>
          <IncidentRecord incidentId={recorded} as="staff" />
        </>
      )}
    </Stack>
  );
}
